import React from 'react';
import { string } from 'prop-types';
import ReactModal from 'react-modal';
import styled, { css } from 'styled-components';

const ReactModalAdapter = ({ className, ...props }) => {
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;

  return (
    <ReactModal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  );
};

const Modal = styled(ReactModalAdapter)`
  ${({
    theme: {
      boxShadow, color, spacing,
    }, onTop,
  }) => css`
    &__overlay {
      z-index: 2;
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-color: rgba(255, 255, 255, 0.5);
    }

    &__content {
      text-align: center;
      background-color: ${color.white};
      position: absolute;
      top: ${onTop ? '10px' : '25%'};
      left: 27px;
      right: 27px;
      overflow-y: scroll;
      max-height: 100%;
      border-radius: 23px;
      box-shadow: ${boxShadow.default};
      outline: none;
      padding: ${spacing.xl4};
      padding-top: ${spacing.xl6};
    }
  `}
`;

ReactModalAdapter.defaultProps = {
  className: 'Modal',
};

ReactModalAdapter.propTypes = {
  className: string,
};

export default Modal;
